export function getMediaUrl(path: string) {
  return `/api/media/${path.replace(/^\/+/, "")}`;
}
